import React from "react";
import classNames from "classnames";

import { IconProps } from "./types";

const Icon = ({
  className,
  color = "default",
  icon,
  size = "medium",
  title,
  ...rest
}: IconProps) => {
  const Element: React.ElementType = icon;
  const iconClasses = classNames(
    "rds-Icon",
    {
      [`rds-Icon--${color}`]: color !== "default",
      [`rds-Icon--${size}`]: size !== "medium",
    },
    className
  );

  const accessibilityProps = title
    ? { title, role: "img" }
    : { focusable: false, "aria-hidden": true };

  return <Element className={iconClasses} {...accessibilityProps} {...rest} />;
};

Icon.displayName = "Icon";

export default Icon;
